module.exports = __webpack_public_path__ + "static/media/haken-grau.fc6d42c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appchallengecenter/haken-grau.svg
// module id = 455
// module chunks = 0